import { Switch } from "@mui/material";
import { usePushNotifications } from "./pushContext";

const DEVICE_NOUN = { ANDROID: "phone", IOS: "phone", WEB: "browser" };

const helpText = ({ permission, registered, optedOut }, noun) => {
  if (permission === "denied") {
    return `Notifications are blocked for Kothar. Allow them in your ${noun} settings, then come back here.`;
  }
  if (registered) return `Alerts reach this ${noun} even when Kothar is closed.`;
  if (optedOut) return `Off for this ${noun}. You still see every alert inside Kothar.`;
  return `Get alerts on this ${noun} as soon as they happen, even when Kothar is closed.`;
};

/** Per-device switch for push alerts. Renders nothing where push cannot work (e.g. an unconfigured browser). */
const PushNotificationsCard = ({ platform = "WEB" }) => {
  const { status, busy, enable, disable } = usePushNotifications();
  if (!status.supported) return null;

  const noun = DEVICE_NOUN[platform] ?? "device";
  const blocked = status.permission === "denied";

  return (
    <div className="rounded-2xl border border-app-border bg-app-surface p-4 sm:p-5 flex items-center justify-between gap-4">
      <div className="min-w-0">
        <h3 className="text-base font-semibold text-app-text m-0">
          Push notifications on this {noun}
        </h3>
        <p className="text-sm text-app-text-secondary m-0 mt-1">{helpText(status, noun)}</p>
      </div>
      <Switch
        checked={status.registered}
        disabled={busy || blocked}
        onChange={(_, checked) => (checked ? enable() : disable())}
        inputProps={{ "aria-label": `Push notifications on this ${noun}` }}
      />
    </div>
  );
};

export default PushNotificationsCard;
